// libraries
import { TextInput as InterstateTextInput } from '@interstate/components/TextInput';
import { withSelectOnFocus } from '../selectOnFocus/withSelectOnFocus';

/**
 * Thin pass-through wrapper over Interstate's TextInput that adds select-all
 * on focus (so a mouse click highlights the value the same way Tab does).
 * Toggle off => identical to the raw TextInput.
 */
export const TextInput = withSelectOnFocus(InterstateTextInput);

TextInput.displayName = 'TextInput';
